import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faXmark, faUserShield } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from './utils/axiosinstance';

// Admin panel: who may see and annotate videos others shared for review.
// Admins always can; everyone else needs to be on this list.
const ReviewerAccessPanel = () => {
    const [reviewers, setReviewers] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [newName, setNewName] = useState('');
    const [error, setError] = useState(null);

    const apply = (data) => {
        setReviewers(data.reviewers || []);
        setAdmins(data.admins || []);
    };

    useEffect(() => {
        axiosInstance.get('/api/admin/reviewers/')
            .then((r) => apply(r.data))
            .catch((e) => console.error('Error loading reviewers:', e));
    }, []);

    const setAccess = async (username, access) => {
        setError(null);
        try {
            const r = await axiosInstance.post('/api/admin/reviewers/', { username, access });
            apply(r.data);
            if (access) setNewName('');
        } catch (e) {
            setError(e?.response?.data?.error || 'Could not update access');
        }
    };

    return (
        <div className="bg-white bg-opacity-10 rounded-lg p-3 text-white">
            <div className="flex flex-wrap items-center gap-2">
                <span className="font-semibold mr-2" title="Who can see and annotate videos others shared for review">Shared-video access:</span>
                {admins.map((a) => (
                    <span key={a} className="flex items-center gap-2 px-3 py-1 rounded-full bg-sil-blue-500 bg-opacity-60 text-sm"
                          title="Admin — always has access">
                        <FontAwesomeIcon icon={faUserShield} />
                        {a}
                    </span>
                ))}
                {reviewers.filter((r) => !admins.includes(r.toLowerCase())).map((r) => (
                    <span key={r} className="flex items-center gap-2 px-3 py-1 rounded-full bg-black bg-opacity-30 text-sm">
                        {r}
                        <button
                            onClick={() => setAccess(r, false)}
                            className="w-5 h-5 rounded-full hover:bg-white hover:bg-opacity-20 flex items-center justify-center"
                            title="Remove shared-video access"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </span>
                ))}
                <form
                    className="flex items-center gap-2"
                    onSubmit={(e) => { e.preventDefault(); if (newName.trim()) setAccess(newName.trim(), true); }}
                >
                    <input
                        type="text"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                        placeholder="account email"
                        className="rounded-full px-3 h-8 bg-black bg-opacity-30 text-white placeholder-white placeholder-opacity-40 outline-none text-sm w-56"
                    />
                    <button type="submit"
                            className="flex items-center gap-1 px-3 h-8 rounded-full bg-sil-green-500 hover:bg-sil-green-400 text-sm font-semibold"
                            title="Grant shared-video access to an existing account">
                        <FontAwesomeIcon icon={faUserPlus} />
                        Add
                    </button>
                </form>
                {error && <span className="text-red-300 text-sm">{error}</span>}
            </div>
        </div>
    );
};

export default ReviewerAccessPanel;
